'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _themeColors = require('./themeColors');

var _themeColors2 = _interopRequireDefault(_themeColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DSHeader = function (_React$Component) {
  _inherits(DSHeader, _React$Component);

  function DSHeader() {
    _classCallCheck(this, DSHeader);

    return _possibleConstructorReturn(this, (DSHeader.__proto__ || Object.getPrototypeOf(DSHeader)).apply(this, arguments));
  }

  _createClass(DSHeader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        var event = Object.assign(new window.Event('DSHeroTheme'), {
          theme: this.props.config.theme
        });
        window.dispatchEvent(event);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof window !== 'undefined') {
        var event = Object.assign(new window.Event('DSHeroTheme'), {
          theme: newProps.config.theme
        });
        window.dispatchEvent(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var title = content.title;


      var classes = (0, _classnames2.default)('ds-header', className);

      var themeColor = _themeColors2.default[config.theme || 'theme-background-color-pay-blue'];
      return _react2.default.createElement(
        'header',
        {
          id: config.id,
          className: classes,
          'data-building-block': 'organism',
          style: { backgroundColor: themeColor }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-12 ds-header__container' },
              _react2.default.createElement(
                'a',
                {
                  href: title.href,
                  'data-pa-click': 'Header-Logo-PayPal Logo',
                  className: 'ds-header__logo pypl-logo pypl-logo--white pypl-logo--monogram'
                },
                'PayPal'
              ),
              _react2.default.createElement(
                'a',
                { href: title.href, className: 'ds-header__title pp-sans-big-light' },
                title.text
              )
            )
          )
        )
      );
    }
  }]);

  return DSHeader;
}(_react2.default.Component);

exports.default = DSHeader;


DSHeader.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    title: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  className: _propTypes2.default.string
};

DSHeader.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-pay-blue'
  },
  content: {
    title: {
      text: 'Design System Guidelines',
      href: '/webapps/mpp/guidelines'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/ds-header/DSHeader.js
// module id = 1082
// module chunks = 4